import { defineComponent, ref, computed, onMounted, watch, toRef } from "vue";
import { V as VaFileUploadKey } from "../types-8c5c5611.mjs";
import { u as useTextColor } from "../../../composables/useTextColor-d6b2d8c3.mjs";
import { V as VaFileUploadUndo } from "../VaFileUploadUndo/index-8c480db4.mjs";
import { V as VaButton } from "../../va-button/index-e7ff1275.mjs";
import { V as VaListItem, a as VaListItemSection } from "../../va-list/index-82910b3a.mjs";
import { d as colorToRgba } from "../../../services/color/utils-e7c3fc9a.mjs";
import { u as useStrictInject } from "../../../composables/useStrictInject-08ce5ce6.mjs";
import { u as useFocus } from "../../../composables/useFocus-1b4e6b2f.mjs";
import { u as useBem } from "../../../composables/useBem-33d80128.mjs";
import { u as useTranslation } from "../../../composables/useTranslation-389ad6ba.mjs";
const INJECTION_ERROR_MESSAGE = "The VaFileUploadGalleryItem component should be used in the context of VaFileUpload component";
const _sfc_main = defineComponent({
  name: "VaFileUploadGalleryItem",
  components: {
    VaFileUploadUndo,
    VaButton,
    VaListItem,
    VaListItemSection
  },
  emits: ["remove"],
  props: {
    file: { type: Object, default: null },
    color: { type: String, default: "success" },
    ariaRemoveFileLabel: { type: String, default: "$t:removeFile" }
  },
  setup(props, { emit }) {
    const {
      undo,
      disabled,
      undoDuration
    } = useStrictInject(VaFileUploadKey, INJECTION_ERROR_MESSAGE);
    const { isFocused, onFocus, onBlur } = useFocus();
    const previewImage = ref("");
    const removed = ref(false);
    const overlayStylesComputed = computed(() => ({
      backgroundColor: colorToRgba(props.color, 0.7)
    }));
    const classesComputed = useBem("va-file-upload-gallery-item", () => ({
      notImage: !previewImage.value,
      focused: isFocused.value,
      undo: removed.value
    }));
    const removeImage = () => {
      if (undo.value) {
        removed.value = true;
        setTimeout(() => {
          if (!removed.value) {
            return;
          }
          emit("remove");
          removed.value = false;
        }, undoDuration.value ?? 0);
      } else {
        emit("remove");
        removed.value = false;
      }
    };
    const recoverImage = () => {
      removed.value = false;
    };
    const convertToImg = () => {
      if (!props.file.name || !props.file.image) {
        return;
      }
      if (props.file.image.url) {
        previewImage.value = props.file.image.url;
      } else if (props.file.image instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(props.file.image);
        reader.onload = (e) => {
          var _a, _b;
          if (((_a = e.target) == null ? void 0 : _a.result).includes("image")) {
            previewImage.value = (_b = e.target) == null ? void 0 : _b.result;
          }
        };
      }
    };
    onMounted(convertToImg);
    watch(() => props.file, convertToImg);
    return {
      ...useTranslation(),
      undo,
      ...useTextColor(toRef(props, "color")),
      removed,
      disabled,
      isFocused,
      previewImage,
      classesComputed,
      overlayStylesComputed,
      onBlur,
      onFocus,
      removeImage,
      recoverImage
    };
  }
});
export {
  _sfc_main as _
};

import '../../../../VaFileUploadGalleryItem.css';
//# sourceMappingURL=VaFileUploadGalleryItem.vue_vue_type_script_lang-8cedf399.mjs.map
